import vars from '../helpers';

let $headerBurger = $('.header__burger');
let $headerLinkNav = $('.header__link');

$headerBurger.on('click', (e) => {
	if (!vars.isMobile()) {
		return;
	}

	let $target = $(e.currentTarget);
	let $targetHeader = $target.closest('.header');
	let $targetNav = $target.closest('.header').find('.header__nav');

	if (!$targetHeader.hasClass('is-nav')) {
		$targetHeader.addClass('is-nav');
		$targetNav.fadeIn(300);
	} else {
		$targetHeader.removeClass('is-nav');
		$targetNav.fadeOut(300);
	}
});

$headerLinkNav.on('click', (e) => {
	if (!vars.isMobile()) {
		return;
	}

	let $target = $(e.currentTarget);
	let $targetHeader = $target.closest('.header');
	let $targetNav = $target.closest('.header').find('.header__nav');

	$targetHeader.removeClass('is-nav');
	$targetNav.fadeOut(300);
});